import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { SCREENS } from '../../responsive';
import {
  buildGoogleMapsSearchUrl,
  formatObscuredLocationQuery,
  sanitizeAddressString,
} from '../../../helpers/formatAddress';

const LocationSection = styled.div<{ $isDesktopOnly?: boolean }>`
  ${tw`my-6`}
  ${({ $isDesktopOnly }) =>
    $isDesktopOnly &&
    `
    display: none;
    @media (min-width: ${SCREENS.md}) {
      display: block;
    }
  `}
`;

const TripLabel = styled.div`
  ${tw`text-sm font-semibold mb-3`}
`;

const LocationText = styled.div`
  ${tw`text-text-secondary mb-2 cursor-pointer`}
`;

interface TripLocationProps {
  location: any;
  isDesktopOnly?: boolean;
  isAirport?: boolean;
}

export const TripLocation: React.FC<TripLocationProps> = ({
  location,
  isDesktopOnly,
  isAirport,
}) => {
  const openGoogleMaps = () => {
    if (!location) return;
    const query = isAirport
      ? location.name?.trim() || formatObscuredLocationQuery(location)
      : formatObscuredLocationQuery(location);
    if (!query) return;
    window.open(buildGoogleMapsSearchUrl(query), '_blank');
  };

  const displayAddress = () => {
    // If it's an airport, show the name
    if (isAirport && location?.name) {
      return location.name;
    }
    // If it's not an airport, show only the city (don't show address)
    if (!isAirport && location?.city) {
      return location.city;
    }
    // Fallback: if name exists, show it
    if (location?.name) {
      return location.name;
    }
    const obscured = formatObscuredLocationQuery(location);
    if (obscured) {
      return obscured.split(',')[0]?.trim() || obscured;
    }
    return sanitizeAddressString(String(location?.address || 'Location'));
  };

  if (!location) return null;

  return (
    <LocationSection $isDesktopOnly={isDesktopOnly}>
      <TripLabel>Pickup & return location</TripLabel>
      <LocationText onClick={openGoogleMaps}>On-site at {displayAddress()}</LocationText>
    </LocationSection>
  );
};
